module.exports = __webpack_public_path__ + "static/about-image-4_d-90b980539672bf27b6149d8e68e9ef50.jpg";